import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { PoliticaSenha } from '../../model/politica-senha';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SegurancaService {

    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient) { }

    obterPoliticaSenha() : Observable<PoliticaSenha> {
        return this.http.get<PoliticaSenha>(environment.backendBaseUrl + '/manager/politicasenha', this.options).pipe(
            catchError(this.handleErrorObservable));
    }

    salvar(politicaSenha : PoliticaSenha) : Observable<PoliticaSenha> {
        return this.http.put<PoliticaSenha>(environment.backendBaseUrl + `/manager/organizacoes/${politicaSenha.organizacaoId}/politicasenha`, politicaSenha).pipe(
            catchError(this.handleErrorObservable));
    }

    private handleErrorObservable(error: HttpErrorResponse | any) {
        console.error(error.error.message);
        return observableThrowError(error.error || error);
    }
}
